<template>
    <div>
        <b-modal id="paymentSystems" title="Выбор платежной системы" ok-title="Отмена" :ok-only="true" size="lg" @hide="resetData">
            <b-card-group deck>
                <b-card v-for="paymentSystem in paymentSystems" key="paymentSystem" :class="{disabled: !paymentSystem.active, selected: (selectedPaymentSystem && selectedPaymentSystem.id === paymentSystem.id)}" @click="startPayment(paymentSystem)" overlay no-body style="max-width: 129px;" :img-src="paymentSystem.image" :img-alt="paymentSystem.title"></b-card>
            </b-card-group>
            <template slot="modal-footer">
                <p v-if="selectedPaymentSystem" class="mr-auto my-auto">Выбранная платежная система: {{ selectedPaymentSystem.title }}</p>
                <b-btn v-if="!paymentForm" :disabled="true">Продолжить</b-btn>
                <div v-else v-html="paymentForm"></div>
            </template>

            <vue-toastr ref="toastr"></vue-toastr>
        </b-modal>
    </div>
</template>

<script>
    import Toastr from 'vue-toastr'

    export default {
        name: 'payment',
        components: {
            'vue-toastr': Toastr
        },
        data () {
            return {
                paymentSystems: [],
                selectedPaymentSystem: null,
                paymentForm: ''
            }
        },
        props: {
            orderId: {
                type: String,
                default: null
            }
        },
        mounted () {
            this.loadPaymentSystems()
        },
        methods: {
            loadPaymentSystems () {
                this.axios.get('finance/payment_systems')
                    .then(response => {
                        this.paymentSystems = response.data['payment_systems']
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            resetData () {
                this.selectedPaymentSystem = null
                this.paymentForm = ''
            },
            startPayment (paymentSystem) {
                this.selectedPaymentSystem = paymentSystem
                this.paymentForm = ''
                this.$refs['toastr'].removeByType('error')

                if (!paymentSystem.active) {
                    this.$refs['toastr'].e({
                        msg: 'Данная платежная система не&nbsp;доступна.',
                        timeout: 0
                    })
                    return
                }

                this.axios.post('finance/payment_form', {
                    order_id: this.orderId,
                    payment_system: paymentSystem.id
                })
                    .then(response => {
                        this.paymentForm = response.data
                    })
                    .catch(error => {
                        if (error.response && error.response.data && error.response.data.hasOwnProperty('message')) {
                            this.$refs('vue-toastr').e(error.response.data['message'])
                        } else {
                            this.$refs('vue-toastr').e('Произошла ошибка.')
                        }
                    })
            }
        }
    }
</script>

<style lang="scss">
    #paymentSystems {
        .card {
            cursor: pointer;
            border: none;
            /*border-color: rgba(50,50,50,.5);*/

            overflow: hidden;

            border-radius: 8px;
            opacity: .8;

            &.disabled {
                opacity: .5;
                filter: grayscale(60%);
            }

            &.selected {
                opacity: 1;
                -webkit-box-shadow: 0 0 20px 6px rgba(50,50,50,.5);
                -moz-box-shadow: 0 0 20px 6px rgba(50,50,50,.5);
                box-shadow: 0 0 20px 6px rgba(50,50,50,.5);
            }

            &:hover:not(.disabled) {
                opacity: 1;

                -webkit-box-shadow: 0 0 20px 6px rgba(0,153,51,.5);
                -moz-box-shadow: 0 0 20px 6px rgba(0,153,51,.5);
                box-shadow: 0 0 20px 6px rgba(0,153,51,.5);
            }
            &:hover {
                -webkit-box-shadow: 0 0 20px 6px rgba(50,50,50,.5);
                -moz-box-shadow: 0 0 20px 6px rgba(50,50,50,.5);
                box-shadow: 0 0 20px 6px rgba(50,50,50,.5);
            }
        }
        img.card-img {
            border-radius: 8px;
        }
    }
</style>


// WEBPACK FOOTER //
// Payment.vue?ec415bc4